(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
let currentIndex = 0;
const slides = document.querySelectorAll('.testimonial-slide');
const track = document.getElementById('testimonial-slider-track');
const totalSlides = slides.length;
const slidesToShow = 2;

function updateArrows() {
  const prevArrow = document.getElementById('prevSlide');
  if (currentIndex === 0) {
    prevArrow.style.display = 'none';
  } else {
    prevArrow.style.display = 'flex';
  }
}

function showSlide(index) {
  if (index < 0) {
    currentIndex = totalSlides - slidesToShow;
  } else if (index > totalSlides - slidesToShow) {
    currentIndex = 0;
  } else {
    currentIndex = index;
  }
  track.style.transform = `translateX(-${currentIndex * 50}%)`;
  updateArrows();
}

updateArrows();

if (totalSlides > slidesToShow) {
  document.getElementById('prevSlide').addEventListener('click', () => {
    showSlide(currentIndex - 1);
  });
  document.getElementById('nextSlide').addEventListener('click', () => {
    showSlide(currentIndex + 1);
  });
}

  } catch(e) { console.error(e); }
})();
})();
